export const HomePath = "/"
export const BenefitsPath = "/benefits_page"
export const RequestsPath = "/requests"
export const CatalogPath = "/catalog"
export const PodiumPath = "/podium"
export const CartPath = "/cart"
export const NotificationsPath = "/notifications"
export const UserPath = "/user"
export const ProfilePath = "/profile"
export const TaskPath = "/tasks"
export const ProgramsPath = "/programs"
export const RecoRequestPath = "/reco_request"
export const ChartsPath = "/charts"
export const AdminPath = "/admin"
export const PostPath = "/post"
export const GoalsPath = "/goals"
export const SuggestionsPath = "/suggestions"
export const ComplaintsPath = "/complaints"
export const SupportPath = "/support"
export const CuponsPath = "/cupons"
export const LoginPath = "/login"
export const LogoutPath = "/logout"
export const ActivateUserPath = "/activate"
export const ActivateOrganizationPath = "/needs_activation"
export const ResetPasswordPath = "/reset_password"
export const RecoveryPasswordPath = "/recover/password"
export const ErrorPath = "/error"
export const SurveysPath = "/surveys"
export const EventsPath = "/events"
export const CorpValuesPath = "/corp_values"
export const PerformancePath = "/performance_evaluation"
export const TestingPath = "/testing"
export const OrderDetailsPath = "/profile/order"
export const NotificationsWholePath = "/notifications/notifications"
export const AnnouncementsPath = "/notifications/announcements"
export const OrdersPath = "/orders"
export const GeneralSettingsPath = "/general_settings"
export const ClipGuidePath = "/clip_guide"
export const DeunaVacationsPath =
  "https://apps.powerapps.com/play/e/default-f5b0d682-1497-4db0-9019-660035554e72/a/af49ef43-282a-4738-bc67-7f32af488421?tenantId=f5b0d682-1497-4db0-9019-660035554e72&hint=fda9b154-a2b8-4ae2-bbb7-9ae822abd38f&source=sharebutton&sourcetime=1713366520458"
export const FilesPath = "/files"
export const TelemedicinePath = "/telemedicine"
export const MaintenancePath = "/maintenance"

export const PATHS_WITH_NAVBAR = [
  PodiumPath,
  BenefitsPath,
  RequestsPath,
  CatalogPath,
  CartPath,
  NotificationsPath,
  UserPath,
  TaskPath,
  ProgramsPath,
  PostPath,
  GoalsPath,
  SuggestionsPath,
  ComplaintsPath,
  SupportPath,
  SurveysPath,
  EventsPath,
  PerformancePath,
  OrderDetailsPath,
  NotificationsWholePath,
  AnnouncementsPath,
  ProfilePath,
  CorpValuesPath,
  OrdersPath,
  GeneralSettingsPath,
  TelemedicinePath,
  RecoRequestPath,
]
